import React, { useReducer } from "react"

interface SignUpFlowProviderProps {
  children: React.ReactNode | React.ReactNodeArray
  email?: string
  dateOfBirth?: string
  firstName?: string
  lastName?: string
  multipleEmployeesFound?: boolean
}

const SignUpFlowContext = React.createContext(null)

export const useSignUpFlow = () => React.useContext(SignUpFlowContext)

const actionTypes = {
  saveMember: "SAVE_MEMBER",
  multipleEmployeesFound: "MULTIPLE_FOUND"
}

function signUpFlowReducer(state, action) {
  switch (action.type) {
    case actionTypes.saveMember: {
      return {
        email: action.payload.email,
        dateOfBirth: action.payload.dateOfBirth,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        multipleEmployeesFound: false
      }
    }
    case actionTypes.multipleEmployeesFound: {
      return {
        ...state,
        multipleEmployeesFound: true
      }
    }
    default: {
      throw new Error(`Unhandled type: ${action.type}`)
    }
  }
}

export default function SignUpFlowProvider({
  children,
  email,
  dateOfBirth,
  firstName,
  lastName
}: SignUpFlowProviderProps) {
  const [state, dispatch] = useReducer(signUpFlowReducer, {
    email: email || null,
    dateOfBirth: dateOfBirth || null,
    firstName: firstName || null,
    lastName: lastName || null,
    multipleEmployeesFound: false
  })

  const handleSaveMemberInfoInMemory = (memberInfo) => dispatch({ type: actionTypes.saveMember, payload: memberInfo })
  const saveMultipleEmployeesFound = () => dispatch({ type: actionTypes.multipleEmployeesFound })
  function getHasFoundAccount() {
    return state.email != null && state.dateOfBirth != null && state.firstName != null && state.lastName != null
  }
  return (
    <SignUpFlowContext.Provider
      value={{
        getHasFoundAccount,
        handleSaveMemberInfoInMemory,
        saveMultipleEmployeesFound,
        ...state
      }}
    >
      {children}
    </SignUpFlowContext.Provider>
  )
}
